import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form, Input, Modal } from "antd";
import { LinkOutlined } from "@ant-design/icons";
import templateStore from "@/store/templateStore";
import { GetLocalStorage } from "@/utils/helper";
import type { ICusTemplate } from "@/store/interface/template";

const FormWebsite = ({ initialData }: { initialData?: ICusTemplate }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { saveConfig, updateConfig } = templateStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (initialData) form.setFieldsValue(initialData.config);
  }, []);

  const handleFinish = async (values: { url: string }) => {
    setLoading(true);
    try {
      let result;
      if (initialData) {
        result = await updateConfig(initialData.xid, { config: { url: values.url } });
      } else {
        const serial = await GetLocalStorage("scan-storage", "serial");
        result = await saveConfig({ type: "website", chip_serial: serial, config: { url: values.url } });
      }
      if (result) navigate("/");
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open
      title="Nhập đường dẫn website"
      onCancel={() => navigate(-1)}
      footer={null}
      centered
      width={400}
    >
      <Form form={form} layout="vertical" onFinish={handleFinish} style={{ marginTop: 16 }}>
        <Form.Item
          name="url"
          label="Đường dẫn"
          rules={[
            { required: true, message: "Vui lòng nhập đường dẫn" },
            { type: "url", message: "Đường dẫn không hợp lệ" },
          ]}
        >
          <Input
            prefix={<LinkOutlined />}
            placeholder="https://example.com"
            size="large"
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <Button type="primary" htmlType="submit" loading={loading} block size="large">
            {initialData ? "Cập nhật" : "Xác nhận"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FormWebsite;
